import { CONFIG_COOP_ENABLED } from '@aipb/util/di';
import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'fr-coop-messages-button',
  imports: [MatButtonModule, MatIconModule],
  templateUrl: './coop-messages-button.component.html',
  styleUrls: ['./coop-messages-button.component.scss']
})
export class CoopMessagesButtonComponent {
  // @ts-expect-error foo
  @Input() isLoggedIn: boolean;
  // @ts-expect-error foo
  @Input() hasPersonalContent: boolean;
  // @ts-expect-error foo
  @Input() isPersonalContentEnabled: boolean;

  @Output() action = new EventEmitter();

  enabled = inject(CONFIG_COOP_ENABLED);
}
